import { TimelineView } from '@/components/shared/timeline'
import { useTimelineQuery } from '@/services/timeline'
import { Alert, Box, CircularProgress } from '@mui/material'

interface OrderTimelineProps {
  orderNumber: string
  orderHash: string
}

export default function OrderTimeline({ orderNumber, orderHash }: OrderTimelineProps) {
  const { data: events = [], isLoading, isError } = useTimelineQuery(orderHash, 'order')

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (isError) {
    return (
      <Alert severity='error' sx={{ mx: 2 }}>
        Failed to load timeline. Please try again later.
      </Alert>
    )
  }

  return (
    <TimelineView
      entityName={orderNumber}
      events={events}
      totalItems={events.length}
      itemsPerPage={12}
      excludedFilters={['Patient', 'Medication Requests', 'Investigations', 'Tasks', 'CS notes']}
    />
  )
}
